import { createContext, useContext } from 'react';
import type { UserCountry } from 'src/models/abTest/experiment';
import type { User } from 'src/models/outseta/outseta';

export interface AuthProviderValue {
  user: User | null;
  isLoading: boolean;
  hasUnsubscribed: boolean;
  isTrial: boolean;
  countryCode: UserCountry | null;
  logout: (reason?: 'token_expired' | 'manual', error?: number) => void;
  jooiceFlow: string | null;
  setJooiceFlow: (flow: string | null) => void;
}

export const AuthContext = createContext<AuthProviderValue | undefined>(undefined);

export const useAuth = () => {
  const value = useContext(AuthContext);
  if (!value) throw new Error('useAuth must be used within AuthProvider');
  return value;
};

// Non-throwing variant for consumers that legitimately render both inside and
// outside AuthProvider's subtree (currently only NotificationProvider, mounted
// at the app root for every route including public ones). Returns null when
// no AuthProvider ancestor exists instead of throwing; callers already treat
// `user`/auth fields as optional (`user?.Email`, etc.). Authenticated
// consumers that require a provider MUST keep using `useAuth` above — its
// throw is a deliberate safety property, not the thing being fixed here.
export const useAuthOptional = () => useContext(AuthContext) ?? null;
